import brandDarkGreen from "@/assets/financing/hometree/Powered_by_Hometree_Finance_Logo_-_brand_dark_green.svg.asset.json";
import monoWhite from "@/assets/financing/hometree/Powered_by_Hometree_Finance_Logo_-_mono_white.svg.asset.json";
import { cn } from "@/lib/utils";

const SOURCES = {
  white: monoWhite.url,
  darkGreen: brandDarkGreen.url,
} as const;

const LOGO_ALT = "Powered by Hometree Finance";

type HometreeLogoProps = {
  /** "white" for dark backgrounds, "darkGreen" for light backgrounds. */
  variant?: keyof typeof SOURCES;
  /** Height utilities. The lockup is ~5.3:1, so keep heights small. */
  className?: string;
};

/**
 * Small supporting Hometree Finance brand mark. Intentionally sized well below
 * the CRS Energy header logo so it never competes with it.
 */
export function HometreeLogo({ variant = "white", className }: HometreeLogoProps) {
  return (
    <img
      src={SOURCES[variant]}
      alt={LOGO_ALT}
      className={cn("w-auto", className)}
      loading="lazy"
      decoding="async"
    />
  );
}
